
import {Vue, Component, Watch} from 'vue-property-decorator';
import {TakipEntity} from "@/entity/TakipEntity";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {Product} from "@/enum/Product";
import Dates from "@/components/inputs/Dates.vue";

@Component({
  components: {Dates}
})
export default class TamamlanmayanTakipList extends Vue {
  get icraProAcik(): boolean {
    return this.$helper.lisansEkranlariAcikMi(Product.ICRAPROWEB);
  }

  loading: boolean = false;
  onFly: boolean = false;
  filterLineVisible: boolean = false;

  filters: {
    borcluAdSoyad: string | null;
    alacakliAdSoyad: string | null;
    takipTarihiBaslangic: string | null;
    takipTarihiBitis: string | null;
  } = {
    borcluAdSoyad: null,
    alacakliAdSoyad: null,
    takipTarihiBaslangic: null,
    takipTarihiBitis: null,
  };

  headers = [
    {text: '', align: 'center', sortable: false},
    {text: "Kart No", sortable: true, value: "id"},
    {text: "Borçlu", value: "borclu_ad", sortable: false},
    {text: "Alacaklı", value: "alacakli_ad", sortable: false},
    {text: "Takip Tarihi", value: "takip_tarihi"},
  ];
  hataHeaders = [
    {text: "Kart No", sortable: true, value: "kart_no"},
    {text: 'Durum', value: "durum", sortable: false},
    {text: "Karta Git", value: "karta_git", sortable: false},
  ];
  hataItems: Array<{
    kart_no: number,
    hata_mesaji: Array<any>
  }> = [];
  items = [];
  serverItemsLength = 0;
  options: {
    sortBy: string[];
    sortDesc: boolean[];
    page: number;
    itemsPerPage: number;
  } = {sortBy: [] as string[], sortDesc: [] as boolean[], page: 1, itemsPerPage: 10};
  secilenTakipler = [];
  dialogAktif = false;

  buildActiveFilters() {
    const activeFilters: Record<string, any> = {};
    const {borcluAdSoyad, alacakliAdSoyad, takipTarihiBaslangic, takipTarihiBitis} = this.filters;
    if (borcluAdSoyad?.trim()) activeFilters.borcluAdSoyad = borcluAdSoyad.trim();
    if (alacakliAdSoyad?.trim()) activeFilters.alacakliAdSoyad = alacakliAdSoyad.trim();
    if (takipTarihiBaslangic) activeFilters.takipTarihiBaslangic = takipTarihiBaslangic;
    if (takipTarihiBitis) activeFilters.takipTarihiBitis = takipTarihiBitis;
    return activeFilters;
  }

  filtreAra() {
    this.options = {...this.options, page: 1};
  }

  sifirla() {
    this.filters = {
      borcluAdSoyad: null,
      alacakliAdSoyad: null,
      takipTarihiBaslangic: null,
      takipTarihiBitis: null,
    };
    this.options = {...this.options, page: 1};
  }

  @Watch('options')
  async load() {
    if (!this.icraProAcik) {
      return;
    }
    this.loading = true;
    try {
      const size = this.options.itemsPerPage;
      const from = (this.options.page - 1) * size;
      const response = await this.$http.post(`/api/v1/takipler?size=${size}&from=${from}`, {
        filters: {
          ...this.buildActiveFilters(),
          takipDurumu: "acilmamis",
        },
        sortBy: this.options.sortBy,
        sortDesc: this.options.sortDesc
      });
      this.serverItemsLength = response.total;
      const newItems: TakipEntity[] = response.data.map((item: any) => item._source || item);
      this.items = newItems;
    } catch (error) {
      console.error("Load error:", error);
    } finally {
      this.loading = false;
    }
  }

  kartaGit(kartNo: any) {
    const route = this.$router.resolve(ProgramPaths.icrapro + "/takip-ekle/" + kartNo);
    window.open(route.href, '_blank');
  }

  async xmlAl() {
    try {
      this.onFly = true;
      this.hataItems = [];
      for (const takip of this.secilenTakipler) {
        let response = await this.$http.get('/api/v1/takip/' + takip.id + '/xml-kontrol');
        if (response.code != 200) {
          this.hataItems.push({
            kart_no: takip.id,
            hata_mesaji: response.hata_mesaji
          })
        }
      }
      if (this.hataItems.length > 0)
        this.dialogAktif = true;
      else {
        let idler = this.secilenTakipler.map((item: any) => item.id);
        const file = await this.$helper.requestXmlFile('/api/v1/takip/online/toplu-xml-indir', {
          method: 'POST',
          data: idler,
          returnFile: true,
          fallbackFileName: 'İcraProTakipXml.xml'
        });
        this.$emit("xml-file", file);
      }
    } catch (e) {
      console.error("xml alırken hata oluştu. ", e.message);
    } finally {
      this.onFly=false;
    }
  }
}
